/**
 * 一覧画面の見出し。タイトル + 説明 1 行 + 右に主要アクション(Primary 1 + Secondary)。
 * パンくずは外殻のコマンドバーが出すので持たない。
 */
import type { ReactNode } from "react";

export function PageHeader({
  title,
  description,
  primary,
  secondary,
}: {
  title: string;
  description?: ReactNode;
  /** 1 つだけ(`<Button type="primary">`) */
  primary?: ReactNode;
  /** 補助の操作(Excel 出力など)。primary の左に並ぶ */
  secondary?: ReactNode;
}) {
  return (
    <header className="ui-pagehead">
      <div>
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {(primary || secondary) && (
        <div className="ui-pagehead-actions">
          {secondary}
          {primary}
        </div>
      )}
    </header>
  );
}
